( function( $ ) {
    /* Carousel */
  
    /* Slick carousel */
    var $carousel = $('.-js-carousel');
    
    var carousel_settings = {
      slidesToShow: 1,
      sldesToScroll: 1,
      arrows: true,
      dots: true,
      waitForAnimate: true,
      swipe: true,
      touchMove: true,
      accessibility: true,   
      nextArrow: '<button class="carousel__arrow -next"><span class="sr-only">Scroll naar links</span></button>',
      prevArrow: '<button class="carousel__arrow -previous"><span class="sr-only">Scroll naar rechts</span></button>',
      infinite: true,
      mobileFirst: true,
      centerMode: false
    };
    
    // Init
    $carousel.slick(carousel_settings);
  
    // Reslick only if it's not slick()
    $(window).on('resize', function() {
      // if (!$usp_carousel.hasClass('slick-initialized')) {
      //   return $usp_carousel.slick(usp_carousel_settings);
      // }
    });
    
  } )( jQuery );